<template>
<div>
  <!-- TITLE -->
  <h5 class="mt-2" id="policyValidationsTitle">
    {{ 'VALIDATIONS' | translate }}
    ({{ product }})
  </h5>

  <div class="mt-4">
    <table class="table table-sm table-striped" aria-describedby="policyValidationsTitle">
      <tbody>
        <tr v-for="val in sortedValidations">

          <!-- VALIDATION ICON -->
          <th scope="row" class="text-center">
            <i class="fa fa-fw"
               :class="validationIcon(val.level)"
               v-tooltip="val.level"
               aria-hidden="true"
            ></i>
          </th>

          <!-- VALIDATION TEXT -->
          <td>{{ val.description | decodeEntity }}</td>

        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
export default {
  props: [ 'product', 'validations' ],
  data: function () {
    return {
    }
  },
  computed: {
    sortedValidations() {
      return this.validations.sort(this.sortValidations);
    }
  },
  methods: {
    sortValidations(val1, val2) {
      if (val1.level === 'ERROR' || (val1.level !== 'ERROR' && val2.level !== 'ERROR' && val1.level > val2.level)) return -1;
      if (val1.level < val2.level) return 1;
      return 0;
    },
    validationIcon(valLevel) {
      switch (valLevel) {
        case 'ERROR': return 'fa-exclamation-triangle fa-lg text-danger';
        case 'WARN': return 'fa-exclamation-triangle fa-lg text-warning';
        case 'INFO': return 'fa-info-circle fa-lg text-info';
        case 'AUDIT': return 'fa-user text-dark';
        default: return 'invisible';
      }
    }
  }
}
</script>

<style scoped>
  th[scope="row"] {
    width: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/case/PolicyValidations.vue